import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  h2 {
    margin-bottom: 10px;
    &.header {
      font-size: 20px;
      font-weight: 600;
      color: #1e3666;
    }
  }
  .upload-file-config {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .upload-file-config-button {
    border-radius: 8px;
    border: 0;
    background-color: #174a83;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    font-weight: 600;
    font-size: 15px;
    height: 40px;
    box-shadow: none;
  }
  .preview-file-inf {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    font-weight: 600;
    margin-left: 30px;
  }

  .title-button {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    font-weight: 600;
    color: #1e3666;
  }
  .ant-progress-text {
    color: #fff !important;
  }
  .ant-input-number-input,
  .ant-picker,
  .ant-picker-input > input {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }
`;
